// Components
import FriendBonus from "assets/icons/glory/invite_bonus.svg?react";
import Button from "../../atoms/Button";

// Hooks
import useTranslate from "../../../hooks/useTranslate";
import useFormatBalance from "../../../hooks/useFormatBalance";

// Icons

import "./styles.sass";

type InviteFriendLinkProps = {
  onClick: () => void;
  amount: number;
};

const InviteFriendBonus = (props: InviteFriendLinkProps) => {
  const { amount, onClick: handleClick } = props;
  const t = useTranslate();
  const formatNumber = useFormatBalance();

  return (
    <div className="InviteFriendBonus">
      <div className="InviteFriendBonus-block">
        <div className="InviteFriendBonus-block-title">
          <FriendBonus />
          <span className="InviteFriendBonus-block-title__text">
            {t("referral.bonus.title")}
          </span>
        </div>
        <span className="InviteFriendBonus-block__amount">
          {formatNumber(amount)}
        </span>
      </div>
      <div className="InviteFriendBonus-btn">
        <Button
          htmlType="button"
          label={t("referral.bonus.button")}
          variation="transparent"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default InviteFriendBonus;
